import { parsePhoneNumber } from "libphonenumber-js/max";

/**
 * Normalize an e164 phone number
 * The case appears on current_user.numbers
 * (ported from the legacy dashboard)
 * @param phoneNumber - Phone number in invalid e164 format (ex: 336123456789)
 * @param prefix - Optional prefix to pass to the normalizer. If used, it adds prefix to number.
 * @returns Phone number in valid e164 format (ex: +33123456789)
 */
export const normalizeNumber = (phoneNumber: string, prefix = ""): string =>
  phoneNumber.startsWith("+") || phoneNumber === "anonymous"
    ? phoneNumber
    : `+${prefix}${phoneNumber}`;

/**
 * Format an e164 phone number to the international format
 * (ported from the legacy dashboard)
 * @param phoneNumber - Phone number in e164 format (ex: 33176420302)
 * @returns Phone number in international format (ex: +33 1 76 42 03 02)
 */
export const formatInternational = (phoneNumber: string): string => {
  try {
    return parsePhoneNumber(normalizeNumber(phoneNumber)).formatInternational();
  } catch (_) {
    // invalid phone number; fallback to the original format
    return phoneNumber;
  }
};

/**
 * Convert phone number to simple number removing '+' and whitespaces
 * @param {string} [value] - phone number to convert
 * @returns {string|undefined} number as string
 */
export function cleanLineValue(value: string) {
  return value.replace(/(^\s*00|\s+|\+)/g, "");
}

export function getParsedPhoneNumber(phoneNumber: string) {
  try {
    return parsePhoneNumber(phoneNumber).number;
  } catch (err) {
    console.error(err);
    return "";
  }
}
